import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

export const ecgResultsColumns = [
  createColumn({
    keyName: "date",
    header: () => i18next.t("patientPage_columns_recorded"),
    cell: (info) => info.renderValue(),
    size: 240,
  }),
  createColumn({
    keyName: "duration",
    header: () => i18next.t("patientPage_columns_duration"),
    cell: (info) => info.renderValue(),
    size: 120,
  }),
  createColumn({
    keyName: "leads",
    header: () => i18next.t("patientPage_columns_leads"),
    cell: (info) => info.renderValue(),
    size: 100,
  }),
  createColumn({
    keyName: "heartRate",
    header: () => i18next.t("patientPage_columns_heart_rate"),
    cell: (info) => info.renderValue(),
    size: 140,
  }),
  createColumn({
    keyName: "result",
    header: () => i18next.t("patientPage_columns_result"),
    cell: (info) => info.renderValue(),
    size: 220,
  }),
];
